'use strict'

import VPSearchFormContent from './vacation-package-content'

const { PUBLIC_URL = '/home/public/' } = process.env

const CONTENT = {
  home: {
    heroBackground: `${PUBLIC_URL}assets/images/photos/pcln-hp-hero-beach.jpg`,
    fallSaleBackground:
      `${PUBLIC_URL}assets/images/promos/flights-fall-sale.jpg`,
    heroBackgroundHome:
      `${PUBLIC_URL}assets/images/photos/pcln-hp-hero-beach.jpg`,
    heroBackgroundHomeWebP:
      `${PUBLIC_URL}assets/images/photos/pcln-hp-hero-beach.webp`,
    heroBackgroundHomeNewSearch:
      `${PUBLIC_URL}assets/images/photos/pcln-hp-hero-beach-top-view.jpg`,
    heroBackgroundHomeNewSearchWebP:
      `${PUBLIC_URL}assets/images/photos/pcln-hp-hero-beach-top-view.webp`,
    heroBackgroundHatchback:
      `${PUBLIC_URL}assets/images/photos/pcln-hp-hero-hatchback.jpg`,
    heroBackgroundHomeNewSearchWebPOptimized:
      `${PUBLIC_URL}assets/images/photos/pcln-hp-hero-beach-top-view-optimized.webp`,
    heroBackgroundHotels:
      `${PUBLIC_URL}assets/images/photos/pcln-hp-hero-hotels.jpg`,
    heroBackgroundHotelsWebP:
      `${PUBLIC_URL}assets/images/photos/pcln-hp-hero-hotels.webp`,
    heroBackgroundVP:
      `${PUBLIC_URL}assets/images/photos/pcln-hp-hero-packages.jpg`,
    heroBackgroundVPWebP:
      `${PUBLIC_URL}assets/images/photos/pcln-hp-hero-packages.webp`,
    heroBackgroundTrips:
      `${PUBLIC_URL}assets/images/photos/pkg_trips_bg_img.jpg`,
    heroBackgroundTripsWebp:
      `${PUBLIC_URL}assets/images/photos/pkg_trips_bg_img.webp`,
    bestPriceGuarantee:
      '<span class="best-price-text">best price.</span>&nbsp;<span class="guaranteed-text">guaranteed.</span>&nbsp;We guarantee the lowest price on everything you book.',
    powerStatement1:
      '<span class="power-text">Powering America\'s trips, one deal at a time.</span><span class="slogan">Whatever\'s on the line.</span>',
    powerStatement2:
      '<div class="header">Because every trip matters.</div><div class="three-col"><div>Up to 40% Off When You Sign In</div><div>Free Cancellations<sup>&dagger;</sup></div><div>Best Price Guaranteed</div></div>',
    powerStatementFootnote: '&dagger;On most published-price hotels',
    forms: {
      mobileHeader: 'Discover great deals on',
      hotels: {
        ga: {
          displaySOPQAction: 'Hotel SOPQ Form',
          displayLabelModal: 'Display',
          searchClickSOPQ: 'Hotel SOPQ Search Button',
          searchClickCollections: 'Hotel Collections Search Button',
          searchClickVIP: 'Hotel VIP Search Button',
          sOPQFormElementClick: 'Hotel SOPQ Form',
          hotelFormElementClick: 'Hotel Search',
          searchClickHotel: 'Hotel Search Button',
          searchValidSubmission: 'Hotel Search',
          sopqSearchValidSubmission: 'Hotel SOPQ Search',
          collectionsSearchValidSubmission: 'Hotel Collections Search',
          searchValidSubmissionLabel: 'Valid'
        },
        iconSvg: 'hotelOutline',
        MOBILE_ICON_UPDATE_SVG: 'bed',
        titleExperimental: {
          greeting: 'Discover new deals every day.',
          mobileGreeting: 'Discover Deals on',
          greetingCallout: 'How much will you save?'
        },
        title: {
          greeting: 'Discover New Deals',
          mobileGreeting: 'Discover Deals on',
          call: 'Every Day'
        },
        tabNameExperimental: 'HOTELS',
        bannerExperimental:
          'Want even bigger discounts? Save up to 60% by <span data-autobot-element-id="DASH_TAB_HOTELS_SEARCH_EXPRESS_DEALS" class="sopq-deals-banner-bottom__link">searching Express Deals.</span>',
        tabName: 'Hotels',
        banner:
          'Want even bigger discounts? Save up to 60% by <span data-autobot-element-id="DASH_TAB_HOTELS_SEARCH_EXPRESS_DEALS" class="sopq-deals-banner-bottom__link">searching Express Deals.</span>',
        packages: {
          type: [
            {
              value: 'H',
              text: 'Hotel Only'
            },
            {
              value: 'AH',
              text: 'Hotel + Flight'
            },
            {
              value: 'AHC',
              text: 'Hotel + Flight + Car'
            }
          ]
        },
        inputs: {
          location: {
            placeholderExperimental: 'Where are you going?',
            label: 'Where are you going?',
            errors: {
              INVALID_LOCATION:
                'Please enter your City, Airport, Point of Interest, Hotel Name or U.S. Zip Code'
            }
          },
          checkIn: {
            label: 'Check-in',
            placeholder: 'Choose Date',
            errors: {
              INVALID_CHECK_IN_DATE: 'Please enter a check-in date'
            }
          },
          checkOut: {
            label: 'Check-out',
            placeholder: 'Choose Date',
            errors: {
              INVALID_CHECK_OUT_DATE: 'Please enter a check-out date'
            }
          },
          combinedDates: {
            checkIn: {
              label: 'Dates',
              placeholder: 'Check-in',
              errors: {
                INVALID_CHECK_IN_DATE: 'Please enter a check-in date'
              }
            },
            checkOut: {
              label: '',
              placeholder: 'Check-out',
              errors: {
                INVALID_CHECK_OUT_DATE: 'Please enter a check-out date'
              }
            },
            dateError: {
              COMBINED_DATES_INVALID_DATE: 'Please enter a valid date'
            }
          },
          rooms: {
            label: 'Rooms'
          },
          adultCount: {
            label: 'Adults <span>(18+)</span>'
          },
          childrenCount: {
            label: 'Children <span>(0-17)</span>'
          },
          childrenAges: {
            label: 'Age of each child <span>(at check-in)</span>',
            errors: {
              INVALID_CHILDREN_AGES: 'Please select an age for each child.'
            }
          },
          childAge: {
            placeholder: 'Age'
          },
          submit: 'Find your deal',
          submitV2: 'Search Hotels',
          retailOverrides: {
            promo: 'PROMO TEXT!!'
          },
          sopqOverrides: {
            submit: 'Search Express Deals',
            location: {
              placeholder: 'City or Airport',
              errors: {
                INVALID_LOCATION: 'Please enter your City or Airport'
              }
            }
          }
        },
        brandTagLine: 'COMPARE PRICES FROM THE TOP HOTEL BRANDS YOU TRUST',
        brandLogos: {
          westin: 'westin',
          hyatt: 'hyatt',
          holiday_inn: 'holiday_inn',
          sheraton: 'sheraton',
          la_quinta: 'la_quinta',
          best_Western: 'best_western',
          marriott: 'marriott',
          extended_stay: 'extended_stay',
          quality_inn: 'quality_inn'
        }
      },
      flights: {
        iconSvg: 'planeOutlineEngine',
        MOBILE_ICON_UPDATE_SVG: 'flights',
        titleExperimental: {
          greeting: 'Thousands of deals made every day',
          call: 'Save more on your next flight'
        },
        tabNameExperimental: 'FLIGHTS',
        title: 'Search and Save on Flights',
        tabName: 'Flights',
        bannerExperimental:
          'Want even bigger discounts? Save up to 50% by <span class="sopq-deals-banner-bottom__link">searching Express Deals.</span>',
        banner:
          'For even Deeper Discounts on flights<br><span>Search Express Deals »</span>',
        packages: {
          type: [
            {
              value: 'A',
              text: 'Flight Only'
            },
            {
              value: 'AH',
              text: 'Flight + Hotel'
            },
            {
              value: 'AHC',
              text: 'Flight + Hotel + Car'
            }
          ]
        },
        inputs: {
          type: {
            options: [
              {
                value: 'RT',
                name: 'Round-trip'
              },
              {
                value: 'OW',
                name: 'One-way'
              },
              {
                value: 'MD',
                name: 'Multi-Destination'
              }
            ]
          },
          nonstop: {
            label: 'Non-Stop Flights Only'
          },
          flight: {
            departureLocationExperimental: {
              placeholder: 'Where from?'
            },
            arrivalLocationExperimental: {
              placeholder: 'Where to?'
            },
            departureLocation: {
              label: 'From',
              placeholder: 'City or Airport'
            },
            arrivalLocation: {
              label: 'To',
              placeholder: 'City or Airport'
            },
            departureDate: {
              label: 'Departing',
              placeholder: 'Choose Date'
            },
            returnDate: {
              label: 'Returning',
              placeholder: 'Choose Date'
            },
            // TODO: SETI Cleanup: COMBINE_SEARCH_DATE_FIELDS
            combinedDates: {
              departureDate: {
                label: 'Dates',
                placeholder: 'Departing'
              },
              returnDate: {
                label: 'Returning',
                placeholder: 'Returning'
              }
            }
          },
          passengers: {
            internationalInfantsMessage:
              'Priceline does not support infants on international flights.',
            infantsMoreThanAdultsWarning:
              "Please make sure there's at least 1 adult for each lap infant."
          },
          options: {
            label: 'Advanced flight options',
            cabinClass: {
              label: 'Cabin'
            },
            airline: {
              label: 'Airline',
              placeholder: 'All Airlines'
            }
          },
          submit: 'Find your deal',
          submitV2: 'Search Flights'
        },
        brandTagLine: 'COMPARE PRICES FROM THE TOP AIRLINES YOU TRUST',
        brandLogos: {
          american_airlines: 'american_airlines',
          delta_airlines: 'delta_airlines',
          united_airlines: 'united_airlines',
          spirit_airlines: 'spirit_airlines',
          frontier_airlines: 'frontier_airlines',
          jetblue_airways: 'jetblue_airways',
          alaska_airlines: 'alaska_airlines',
          air_canada: 'air_canada',
          avianca: 'avianca'
        }
      },
      rentalCars: {
        iconSvg: 'carLine',
        MOBILE_ICON_UPDATE_SVG: 'cars',
        titleExperimental: {
          greeting: 'Discover new deals every day.',
          call: 'How much will you save?'
        },
        tabNameExperimental: 'CARS',
        title: 'Search and Save on Rental Cars',
        tabName: 'Cars',
        bestPrice: {
          title: 'Priceline Best Price Guarantee',
          content:
            '<span>If you find a lower price online for the same itinerary we\'ll refund 100% of the difference. <a href="/landing/best-price-guarantee.htm" target="_blank">Learn More</a></span>'
        },
        banner:
          'Want even bigger discounts? Save up to 50% by <span class="sopq-deals-banner-bottom__link">searching Express Deals.</span>',
        inputs: {
          toggleDropOffExperimental: {
            different: 'Return car to a different location',
            same: 'Return car to the same location'
          },
          pickUpLocationExperimental: {
            label: 'Pick-up from',
            placeholder: 'Where from?',
            errors: {
              INVALID_PICK_UP_LOCATION:
                'Please enter your Airport, City, or Point of Interest'
            }
          },
          dropOffLocationExperimental: {
            label: 'Drop-off to',
            placeholder: 'Where to?',
            errors: {
              INVALID_DROP_OFF_LOCATION:
                'Please enter your Airport, City, or Point of Interest'
            }
          },
          toggleDropOff: {
            different: 'Different drop-off location or one-way rental',
            same: 'Same drop-off location'
          },
          pickUpLocation: {
            label: 'Pick-up from',
            placeholder: 'Airport, City, or Point of Interest',
            errors: {
              INVALID_PICK_UP_LOCATION:
                'Please enter your Airport, City, or Point of Interest'
            }
          },
          dropOffLocation: {
            label: 'Drop-off to',
            placeholder: 'Airport, City, or Point of Interest',
            errors: {
              INVALID_DROP_OFF_LOCATION:
                'Please enter your Airport, City, or Point of Interest'
            }
          },
          pickUpDate: {
            label: 'Pick-up date',
            placeholder: 'Pick-up',
            errors: {
              INVALID_PICK_UP_DATE: 'Please select a valid pick-up date.'
            }
          },
          pickUpTime: {
            label: 'Pick-up time',
            placeholder: 'Choose Date'
          },
          dropOffDate: {
            label: 'Drop-off date',
            placeholder: 'Drop-off',
            errors: {
              INVALID_DROP_OFF_DATE: 'Please select a valid drop-off date.'
            }
          },
          dropOffTime: {
            label: 'Drop-off time',
            placeholder: 'Choose Date'
          },
          submit: 'Find your deal',
          submitV2: 'Search Rental Cars'
        }
      },
      vacationPackages: {
        iconSvg: 'pkgLine',
        MOBILE_ICON_UPDATE_SVG: 'luggage',
        title: 'Search and Save on Vacation Packages',
        titleExperimental: {
          greeting: VPSearchFormContent.primaryHeadingDesktop,
          mobileGreeting: 'Discover Deals on',
          call: VPSearchFormContent.secondaryHeading
        },
        tabNameExperimental: 'HOTEL + FLIGHT',
        tabName: 'Hotel + Flight',
        bannerExperimental: VPSearchFormContent.bumperText,
        inputs: {
          type: {
            options: [
              {
                value: 'AH',
                name: 'Hotel + Flight',
                text: 'Hotel + Flight'
              },
              {
                value: 'AHC',
                name: 'Hotel + Flight + Car',
                text: 'Hotel + Flight + Car'
              },
              {
                value: 'AC',
                name: 'Flight + Car',
                text: 'Flight + Car'
              }
            ]
          },
          nonstop: {
            label: 'Non-Stop Flights Only'
          },
          flight: {
            departureLocationExperimental: {
              placeholder: 'Where from?'
            },
            arrivalLocationExperimental: {
              placeholder: 'Where to?'
            },
            departureLocation: {
              label: 'Departing From',
              placeholder: 'Airport or City, or Point of Interest'
            },
            arrivalLocation: {
              label: 'Going To',
              placeholder: 'City or Airport, or Point of Interest'
            },
            departureDate: {
              label: 'Dates',
              placeholder: 'Departing'
            },
            returnDate: {
              label: 'Returning Date',
              placeholder: 'Returning'
            },
            combinedDates: {
              departureDate: {
                label: 'Dates',
                placeholder: 'Departing'
              },
              returnDate: {
                label: 'Returning',
                placeholder: 'Returning'
              }
            }
          },
          hotel: {
            combinedDates: {
              checkIn: {
                label: 'Dates',
                placeholder: 'Check-in',
                errors: {
                  INVALID_CHECK_IN_DATE: 'Please enter a check-in date'
                }
              },
              checkOut: {
                label: '',
                placeholder: 'Check-out',
                errors: {
                  INVALID_CHECK_OUT_DATE: 'Please enter a check-out date'
                }
              },
              dateError: {
                COMBINED_DATES_INVALID_DATE: 'Please enter a valid date'
              }
            }
          },
          rooms: {
            label: 'Hotel Rooms'
          },
          passengers: {
            label: 'Passengers',
            adults: {
              label: 'Adults (18+ years)'
            },
            children: {
              label: 'Children (2 - 17 years)'
            },
            child: {
              label: 'Child'
            }
          },
          travelers: {
            infantsMoreThanAdultsWarning:
              "Please make sure there's at least 1 adult for each lap infant.",
            headcountMoreThanRoomsWarning:
              'Rooms accommodate up to 4 people. You may need additional rooms for your group.',
            childrenAgesWarning:
              "Please enter children's ages to get the best price for your group.",
            internationalWithInfantsWarning:
              'Priceline does not support infants on international flights.',
            internationalWithLapInfantWarning:
              'Priceline does not support lap infants on international flights.'
          },
          submit: 'Find your deal',
          submitV2: 'Search Hotels + Flights'
        },
        promotion:
          '<strong>Save up to $625 when you book your flight and hotel together!</strong>'
      },
      cruises: {
        iconSvg: 'cruiseOutline',
        MOBILE_ICON_UPDATE_SVG: 'cruises',
        title: 'Search and Save on Cruises',
        titleExperimental: {
          greeting: 'Discover new deals every day.',
          mobileGreeting: 'Discover Deals on',
          call: 'How much will you save?'
        },
        tabNameExperimental: 'CRUISES',
        tabName: 'Cruises',
        bannerExperimental:
          'Get a $1000 drink & spa credit when you <span class="sopq-deals-banner-bottom__link"><a href="http://cruises.priceline.com/promotion/member-benefits.do" target="_blank">book a cruise with Priceline.</a></span>',
        inputs: {
          destinations: {
            label: 'Where are you going?'
          },
          cruiseLine: {
            label: 'Which cruise line?'
          },
          zip: {
            label: 'U.S. Zip Code'
          },
          departureDate: {
            label: 'Departure Date'
          },
          cruiseLength: {
            label: 'Cruise length'
          },
          age: {
            label: '55 years or older?'
          },
          submit: 'Find your deal',
          submitV2: 'Search Cruises'
        },
        promotion:
          '<strong><a href="http://cruises.priceline.com/promotion/member-benefits.do" target="_blank">Exclusive Offer</a> $1000 drink &amp; spa credit!</strong>'
      },
      more: {
        tabName: 'More',
        travelOptions: [
          {
            title: 'Manage Your Travel',
            options: [
              {
                title: 'Free Mobile App',
                description: 'Travel apps for iPhone, iPad and Android Devices',
                href: '/download-priceline-negotiator-app',
                img: '',
                class: 'mobile-app'
              },
              {
                title: 'My Trips',
                description: 'Manage your itinerary.',
                href: '/dashboard/#/mytrips',
                img: '',
                class: 'trips'
              },
              {
                title: 'My Profile',
                description: 'Login, bookings, travel preferences and history',
                href: '/myprofile/getPersonalInfo.do',
                img: '',
                class: 'profile'
              },
              {
                title: 'Help',
                description: 'Need help with Priceline.com?',
                href: '/help-page/',
                img: '',
                class: 'help'
              }
            ]
          },
          {
            title: 'Find Travel',
            options: [
              {
                title: 'Hotels Guides',
                description:
                  'Explore Cities, Hotels, Restaurants, and much more…',
                href: '/hotel-reviews-hotel-guides',
                img: '',
                class: 'hotels-guide'
              },
              {
                title: 'Hotel Group Deals',
                description: 'Plan and book your next group hotel',
                href:
                  'https://findgroupdeals.hotelplanner.com/Priceline.cfm?sc=PCLN_HomeTopNav',
                img: '',
                class: 'hotel-deals'
              }
            ]
          }
        ]
      }
    },
    discounts: {
      title: 'For Deeper Discounts - Name Your Own Price®',
      entries: [
        {
          type: 'hotels',
          title: 'Save up to 60% on Hotels*',
          link: 'Bid Now »',
          href: ''
        },
        {
          type: 'flights',
          title: 'Save up to 40% on Flights*',
          link: 'Bid Now »',
          href: '/hotel-reviews-hotel-guides'
        },
        {
          type: 'rentalCars',
          title: 'Save up to 40% on Rental Cars*',
          link: 'Bid Now »',
          href: ''
        }
      ]
    },
    deeperDiscountsButtons: {
      title: {
        question: 'On a budget? ',
        answer: 'Name Your Own Price<sup>&reg;</sup>'
      },
      entries: [
        {
          type: 'hotels',
          title: 'Bid for Hotels',
          href: ''
        },
        {
          type: 'flights',
          title: 'Bid for Hotels',
          href: '/hotel-reviews-hotel-guides'
        },
        {
          type: 'rentalCars',
          title: 'Bid for Cars',
          href: ''
        }
      ]
    },
    mobileApps: {
      background: `${PUBLIC_URL}assets/images/photos/desert_image_2-high.jpg`,
      title: 'Access Priceline Deals Anywhere',
      content: [
        'Get exclusive Tonight Only hotel deals',
        'Access mobile-only hotel, flight, and rental car deals',
        'Stay connected with important trip details anytime, anywhere'
      ],
      form: {
        title: 'Send a download link to my phone',
        placeholder: 'Mobile Number',
        submit: 'Send Text'
      },
      appStore: {
        href:
          'https://itunes.apple.com/us/app/priceline-hotels-flights-cars/id336381998',
        label: 'Download the Priceline App on the App Store'
      },
      playStore: {
        href:
          'https://play.google.com/store/apps/details?id=com.priceline.android.negotiator',
        label: 'Download the Priceline App on the Play Store'
      }
    },
    featuredEntry: {
      title: '<strong>SAVE 60%<sup>*</sup> on hotels.</strong> Get going!',
      body: 'Exclusive savings, no bidding required.',
      link: 'Search Express Deals',
      form: {
        title: 'Search For Express Deals <sup>®</sup>',
        subtitle: 'Save up to 60% Fast and Easy - No Bidding Required!'
      },
      trackingType: 'Click_Express Deal',
      trackingLabel: 'Hotel'
    },
    featuredEntries: [
      {
        img: `${PUBLIC_URL}assets/images/promos/promo-walt-disney-world.jpg`,
        title: 'Walt Disney World® Vacations',
        body:
          'Book your Walt Disney World® tickets here! Plus, complete your vacation and book your hotel.',
        link: 'More Info',
        href: '/partner/hotels/walt-disney-world-v1.html',
        trackingType: 'Theme Park',
        trackingLabel: 'Walt Disney World'
      },
      {
        img: `${PUBLIC_URL}assets/images/promos/promo-universal.jpg`,
        title: 'Universal Orlando® Vacations',
        body:
          'Book Universal Orlando tickets and spectacular on-site hotels here!',
        link: 'More Info',
        href:
          '/promotions/hotels/universal-orlando.html?irefid=HPHT_prm8&irefclickid=UNIVERSAL',
        trackingType: 'Theme Park',
        trackingLabel: 'Universal Orlando'
      },
      {
        img:
          `${PUBLIC_URL}assets/images/promos/Fall-Sale-Homepage-Tile-2017.jpg`,
        title: 'Hotel Deals',
        body: 'Save on your next hotel stay!',
        link: 'Search Now',
        href: '/promotions/hotels/hotel-page.html',
        trackingType: 'Season',
        trackingLabel: 'Hotel Deals'
      },
      {
        img:
          `${PUBLIC_URL}assets/images/promos/Fall-Sale-Homepage-Tile-2017.jpg`,
        title: 'Hotel Deals',
        body: 'Save on your next hotel stay!',
        link: 'Search Now',
        href: '/promotions/hotels/hotel-page.html',
        trackingType: 'Season',
        trackingLabel: 'Hotel Deals'
      }
    ],
    popularDestinations: {
      title: 'Visit Popular Destinations for Less',
      locations: [
        {
          name: 'Las Vegas',
          backgroundClass: 'las-vegas'
        },
        {
          name: 'San Jose',
          backgroundClass: 'san-jose',
          searchLocation: 'San Jose, CA'
        },
        {
          name: 'Aruba',
          backgroundClass: 'aruba'
        },
        {
          name: 'Myrtle Beach',
          backgroundClass: 'myrtle-beach'
        },
        {
          name: 'Virginia Beach',
          backgroundClass: 'virginia-beach'
        }
      ]
    },
    popularDestinationsV2: {
      heading: 'Discover deals in every city',
      data: {
        firstGroup: [
          {
            imageWebP:
              `${PUBLIC_URL}assets/images/destinations/new-york-city.webp`,
            image: `${PUBLIC_URL}assets/images/destinations/new-york-city.jpg`,
            title: '24-HOUR EXCITEMENT',
            staySearchID: '3000016152',
            driveSearchCity: 'New York, NY',
            airSearchCityAirport: 'to-NewYork-NYC',
            href: '/hotel-deals/c3000016152/US/New-York/New-York-Hotels.html'
          },
          {
            imageWebP:
              `${PUBLIC_URL}assets/images/destinations/los-angeles.webp`,
            image: `${PUBLIC_URL}assets/images/destinations/los-angeles.jpg`,
            title: 'CUTTING-EDGE COOL',
            staySearchID: '3000001947',
            driveSearchCity: 'Los Angeles, CA',
            airSearchCityAirport: 'to-LosAngeles-LAX',
            href:
              '/hotel-deals/c3000001947/US/California/Los-Angeles-Hotels.html'
          }
        ],
        secondGroup: [
          {
            imageWebP: `${PUBLIC_URL}assets/images/destinations/orlando.webp`,
            image: `${PUBLIC_URL}assets/images/destinations/orlando.jpg`,
            title: 'THEME PARK PARADISE',
            staySearchID: '3000003349',
            driveSearchCity: 'Orlando, FL',
            airSearchCityAirport: 'to-Orlando-ORL',
            href: '/hotel-deals/c3000003349/US/Florida/Orlando-Hotels.html'
          },
          {
            imageWebP: `${PUBLIC_URL}assets/images/destinations/atlanta.webp`,
            image: `${PUBLIC_URL}assets/images/destinations/atlanta.jpg`,
            title: 'SWEET SOUTHERN CHARM',
            staySearchID: '3000003496',
            driveSearchCity: 'Atlanta, GA',
            airSearchCityAirport: 'to-Atlanta-ATL',
            href: '/hotel-deals/c3000003496/US/Georgia/Atlanta-Hotels.html'
          },
          {
            imageWebP: `${PUBLIC_URL}assets/images/destinations/dallas.webp`,
            image: `${PUBLIC_URL}assets/images/destinations/dallas.jpg`,
            title: 'FOOD CAPITAL',
            staySearchID: '3000021082',
            driveSearchCity: 'Dallas, TX',
            airSearchCityAirport: 'to-Dallas-DAL',
            href: '/hotel-deals/c3000021082/US/Texas/Dallas-Hotels.html'
          }
        ],
        thirdGroup: [
          {
            imageWebP:
              `${PUBLIC_URL}assets/images/destinations/san-francisco.webp`,
            image: `${PUBLIC_URL}assets/images/destinations/san-francisco.jpg`,
            title: 'SOAK UP THE SCENES',
            staySearchID: '3000002244',
            driveSearchCity: 'San Francisco, CA',
            airSearchCityAirport: 'to-SanFrancisco-SFO',
            href:
              '/hotel-deals/c3000002244/US/California/San-Francisco-Hotels.html'
          },
          {
            imageWebP: `${PUBLIC_URL}assets/images/destinations/miami.webp`,
            image: `${PUBLIC_URL}assets/images/destinations/miami.jpg`,
            title: "IT'S BEACH TIME",
            staySearchID: '3000003311',
            driveSearchCity: 'Miami, FL',
            airSearchCityAirport: 'to-Miami-MIA',
            href: '/hotel-deals/c3000003311/US/Florida/Miami-Hotels.html'
          }
        ],
        fourthGroup: [
          {
            imageWebP: `${PUBLIC_URL}assets/images/destinations/denver.webp`,
            image: `${PUBLIC_URL}assets/images/destinations/denver.jpg`,
            title: 'MILE-HIGH MAGIC',
            staySearchID: '3000002573',
            driveSearchCity: 'Denver, CO',
            airSearchCityAirport: 'to-Denver-DEN',
            href: '/hotel-deals/c3000002573/US/Colorado/Denver-Hotels.html'
          },
          {
            imageWebP: `${PUBLIC_URL}assets/images/destinations/seattle.webp`,
            image: `${PUBLIC_URL}assets/images/destinations/seattle.jpg`,
            title: 'PACIFIC NORTHWEST BEAUTY',
            staySearchID: '3000023414',
            driveSearchCity: 'Seattle, WA',
            airSearchCityAirport: 'to-Seattle-SEA',
            href: '/hotel-deals/c3000023414/US/Washington/Seattle-Hotels.html'
          },
          {
            imageWebP: `${PUBLIC_URL}assets/images/destinations/san-diego.webp`,
            image: `${PUBLIC_URL}assets/images/destinations/san-diego.jpg`,
            title: 'RIDE THE WAVES',
            staySearchID: '3000002241',
            driveSearchCity: 'San Diego, CA',
            airSearchCityAirport: 'to-SanDiego-SAN',
            href: '/hotel-deals/c3000002241/US/California/San-Diego-Hotels.html'
          }
        ]
      }
    },
    destinations: {
      title: 'Visit Popular Destinations for Less',
      locations: [
        {
          name: 'Aruba',
          href:
            '/cheap-hotels-aruba-aruba-tk-c328024-hl.hotel-reviews-hotel-guides'
        },
        {
          name: 'Atlanta',
          href:
            '/cheap-hotels-atlanta-georgia-GA-tk-c291690-hl.hotel-reviews-hotel-guides'
        },
        {
          name: 'Atlantic City',
          href:
            '/cheap-hotels-atlantic-city-new-jersey-NJ-tk-c285790-hl.hotel-reviews-hotel-guides'
        },
        {
          name: 'Baltimore',
          href:
            'cheap-hotels-baltimore-maryland-MD-tk-c291460-hl.hotel-reviews-hotel-guides'
        },
        {
          name: 'Boston',
          href:
            '/cheap-hotels-boston-massachusetts-MA-tk-c291810-hl.hotel-reviews-hotel-guides'
        },
        {
          name: 'Brooklyn',
          href:
            '/cheap-hotels-brooklyn-new-york-NY-tk-c286180-hl.hotel-reviews-hotel-guides'
        },
        {
          name: 'Denver',
          href:
            '/cheap-hotels-denver-colorado-CO-tk-c291780-hl.hotel-reviews-hotel-guides'
        },
        {
          name: 'Orlando',
          href:
            '/cheap-hotels-orlando-florida-FL-tk-c291790-hl.hotel-reviews-hotel-guides'
        },
        {
          name: 'Honolulu',
          href:
            '/cheap-hotels-honolulu-hawaii-HI-tk-c287720-hl.hotel-reviews-hotel-guides'
        },
        {
          name: 'Houston',
          href:
            '/cheap-hotels-houston-texas-TX-tk-c291720-hl.hotel-reviews-hotel-guides'
        },
        {
          name: 'Miami',
          href:
            '/cheap-hotels-miami-florida-FL-tk-c291540-hl.hotel-reviews-hotel-guides'
        },
        {
          name: 'Myrtle Beach',
          href:
            '/cheap-hotels-myrtle-beach-south-carolina-SC-tk-c291820-hl.hotel-reviews-hotel-guides'
        },
        {
          name: 'Las Vegas',
          href:
            '/cheap-hotels-las-vegas-nevada-NV-tk-c291680-hl.hotel-reviews-hotel-guides'
        },
        {
          name: 'Los Angeles',
          href:
            '/cheap-hotels-los-angeles-california-CA-tk-c291510-hl.hotel-reviews-hotel-guides'
        },
        {
          name: 'San Antonio',
          href:
            '/cheap-hotels-san-antonio-texas-TX-tk-c290100-hl.hotel-reviews-hotel-guides'
        },
        {
          name: 'San Diego',
          href:
            '/cheap-hotels-san-diego-california-CA-tk-c291830-hl.hotel-reviews-hotel-guides'
        },
        {
          name: 'San Francisco',
          href:
            '/cheap-hotels-san-francisco-california-CA-tk-c291770-hl.hotel-reviews-hotel-guides'
        },
        {
          name: 'Seattle',
          href:
            '/cheap-hotels-seattle-washington-WA-tk-c290290-hl.hotel-reviews-hotel-guides'
        },
        {
          name: 'San Jose',
          href:
            '/cheap-hotels-san-jose-california-CA-tk-c290130-hl.hotel-reviews-hotel-guides'
        },
        {
          name: 'Virginia Beach',
          href:
            '/cheap-hotels-virginia-beach-virginia-VA-tk-c316940-hl.hotel-reviews-hotel-guides'
        }
      ]
    },
    promos: {
      disneyVacations: {
        smallHeadingText: 'A VACATION YOU’LL REMEMBER FOREVER',
        headingText: 'Walt Disney World Vacations',
        contentTextPt1:
          'Book your Walt Disney World tickets here! Plus, complete your vacation and book your hotel.',
        linkUrl: '/partner/hotels/walt-disney-world-v1.html',
        linkTagAction: 'Mobile',
        linkTagLabels: {
          iOS: 'iOS',
          android: 'Android'
        },
        image: `${PUBLIC_URL}assets/images/promos/StarWarsGalaxyEdge.jpg`,
        imageWebP: `${PUBLIC_URL}assets/images/promos/StarWarsGalaxyEdge.webp`
      },
      appDownload: {
        smallHeadingText: 'savings on the go',
        headingText: 'Exclusive Tonight Only Deals. Only in the App.',
        contentTextPt1: 'Discover hotel, flight and rental car deals',
        contentTextPt2: ' exclusively in the app.',
        contentTextPt3:
          ' Download today to stay connected with important trip details \u2014 anytime, anywhere.',
        linkUrls: {
          iOS: '/mobile-app/',
          android: '/mobile-app/'
        },
        linkTagAction: 'Mobile',
        linkTagLabels: {
          iOS: 'iOS',
          android: 'Android'
        },
        image: `${PUBLIC_URL}assets/images/promos/devices.jpg`,
        imageWebP: `${PUBLIC_URL}assets/images/promos/devices.webp`
      },
      expressDeals: {
        linkTagLabel: 'Express Deals',
        linkTagAction: 'Hero Promo',
        image: `${PUBLIC_URL}assets/images/promos/kaley_a.png`,
        imageWebP: `${PUBLIC_URL}assets/images/promos/kaley_a.webp`,
        loadedPromoLabel: 'PromoLoad Y',
        loadedPromoAction: 'Hero Promo'
      },
      cruisePromo: {
        linkTagLabel: 'cruise promo',
        linkTagAction: 'Hero Promo',
        images: [
          {
            image: `${PUBLIC_URL}assets/images/promos/cruise-june.jpg`,
            imageWebP: `${PUBLIC_URL}assets/images/promos/cruise-june.webp`
          }
        ],
        loadedPromoLabel: 'PromoLoad Y',
        loadedPromoAction: 'Hero Promo'
      },
      flexPackage: {
        badgeText: 'NEW',
        titleText: 'TRIP BUILDER',
        headerText1: 'Build your ultimate deal.',
        headerText2: 'Only at Priceline.',
        descriptionText1: 'Get our',
        descriptionText2: 'lowest prices',
        descriptionText3: 'on hotels, flights, and rental cars when you bundle it all in a single booking. Use Trip Builder to spend less time planning and more time traveling.',
        buttonText: 'Start Saving',
        buttonLink: '/trips?utm_source=pcln&utm_medium=landing&utm_campaign=flex_package_launch_Q22019&utm_content=promo_module',
        image: `${PUBLIC_URL}assets/images/promos/flex-packages-section.jpg`,
        imageWebP: `${PUBLIC_URL}assets/images/promos/flex-packages-section.webp`
      }
    },
    barclaysBanner: {
      title:
        'The Priceline Rewards<sup>&trade;</sup> Visa<sup>&reg;</sup> Card',
      graphic: `${PUBLIC_URL}assets/images/graphics/graphic-barclays-card.jpg`,
      background: `${PUBLIC_URL}assets/images/photos/photo-sky.jpg`,
      footnote:
        '*See <a href="https://www.pricelinevisa.com/apply/Landing.action?campaignId=2092&cellNumber=1&referrerid=HOMEPAGE" data-ga-category="PCLN_HOME" data-ga-action="Barclays Banner" data-ga-label="Terms and Conditions">Terms and Conditions</a> for details',
      button: {
        href:
          'https://www.pricelinevisa.com/apply/Landing.action?campaignId=2092&cellNumber=1&referrerid=HOMEPAGE',
        text: 'Start Earning Now'
      },
      perks: [
        {
          title: '5,000',
          subtitle: 'BONUS POINTS',
          line1: 'earned after your',
          line2: 'first purchase*'
        },
        {
          title: '1X',
          subtitle: 'REWARD POINTS',
          line1: 'earned on purchases',
          line2: 'everywhere else*'
        },
        {
          title: '5X',
          subtitle: 'REWARD POINTS',
          line1: 'earned on eligible',
          line2: 'priceline.com<sup>&reg;</sup> purchases*'
        }
      ]
    },
    couponBanner: {
      title: 'Sign up for Exclusive Email-only Coupons',
      subtitle: 'Exclusive access to coupons, special offers and promotions.',
      success: 'Thanks for signing up!',
      form: {
        emailInputPlaceholder: 'example@address.com',
        submit: 'Get Deals',
        sync: 'Submitting'
      }
    },
    couponBannerV2: {
      title: 'Our Biggest Black Friday & Cyber Monday sale ever!',
      subtitle:
        'Over $1 MILLION in extra hotel savings! Only available to email insiders.',
      success:
        'Congratulations! You’re on the list to receive exclusive access to priceline deals and our Black Friday & Cyber Monday sales.',
      form: {
        emailInputPlaceholder: 'Enter your email address',
        submit: 'Sign up',
        sync: 'Submitting'
      }
    }
  },
  SETI_TEST_TEAM_NAME: 'home_landing'
}

export default CONTENT
